import { render, staticRenderFns } from "./salesData.vue?vue&type=template&id=3056183a&scoped=true"
import script from "./salesData.vue?vue&type=script&lang=js"
export * from "./salesData.vue?vue&type=script&lang=js"
import style0 from "./salesData.vue?vue&type=style&index=0&id=3056183a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3056183a",
  null
  
)

export default component.exports